import script from "./StatementUser.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementUser.vue?vue&type=script&setup=true&lang=js"

import "./StatementUser.vue?vue&type=style&index=0&id=54bdae7e&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54bdae7e"]])

export default __exports__